import _ from 'lodash';
import DepsService from 'services/dependencies';

export const ASC_DESC_MAPPING = {
  true: 'asc', // eslint-disable-line quote-props
  false: 'desc', // eslint-disable-line quote-props
};

export const defaultFilterHandler = (item, filters, key) => {
  const filterValue = _.toString(_.get(filters, key)).toLowerCase();
  const itemValue = _.toString(_.get(item, key)).toLowerCase();
  return !filterValue || itemValue.indexOf(filterValue) > -1;
};

export function initGrid(fetchFunction, params = {}) {
  const gridModel = initialGridModel(params);
  const fetchDataFunc = fetchData.bind(null, fetchFunction, gridModel);
  const gotoPageFunc = gotoPage.bind(null, gridModel, fetchDataFunc);

  const gridProto = {
    fetchData: fetchDataFunc,
    applyFilters: applyFilters.bind(null, gridModel, fetchDataFunc),
    sortByColumn: sortByColumn.bind(null, gridModel, fetchDataFunc),
    changePageSize: changePageSize.bind(null, gridModel, fetchDataFunc),
    gotoPage: gotoPageFunc,
    nextPage: nextPage.bind(null, gridModel, gotoPageFunc),
    prevPage: prevPage.bind(null, gridModel, gotoPageFunc),
  };

  return Object.assign({}, gridProto, gridModel);
}

function initialGridModel(params) {
  return {
    loaded: false,
    pagingModel: {
      [DepsService.config.pageNoKey]: params[DepsService.config.pageNoKey] || DepsService.config.defaultPageNo,
      [DepsService.config.pageSizeKey]: params[DepsService.config.pageSizeKey] || DepsService.config.defaultPageSize[0],
      [DepsService.config.sortColumnKey]: params[DepsService.config.sortColumnKey] || DepsService.config.defaultSortColumnKey,
      [DepsService.config.directionKey]: params[DepsService.config.directionKey] === undefined ? DepsService.config.defaultSortDirection : params[DepsService.config.directionKey],
      [DepsService.config.filtersKey]: {},
      retailerId: params['retailerId'] || void 0,
    },
  };
}

function fetchData(fetchFunction, gridModel) {
  return fetchFunction(gridModel.pagingModel);
}

function gotoPage(gridModel, fetchFunction, page) {
  gridModel.pagingModel[DepsService.config.pageNoKey] = Number.isNaN(page) ? 0 : page;
  return fetchFunction();
}

function nextPage(gridModel, gotoPageFunc) {
  let pageNo = gridModel.pagingModel[DepsService.config.pageNoKey];
  return gotoPageFunc(++pageNo);
}

function prevPage(gridModel, gotoPageFunc) {
  let pageNo = gridModel.pagingModel[DepsService.config.pageNoKey];
  return gotoPageFunc(--pageNo);
}

function setFilters(DepsService, gridModel, model, filters) {
  return _.set(model, `${gridModel}.${DepsService.config.filtersKey}`, filters);
}

function removeEmptyFilters(filters = []) {
  return Object.keys(filters).reduce((newFilters, key) => {
    const value = filters[key];
    if (value !== undefined && value !== null && value !== '') {
      newFilters[key] = value;
    }
    return newFilters;
  }, {});
}

function applyFilters(gridModel, fetchDataFunc, filters) {
  gridModel.pagingModel[DepsService.config.filtersKey] = filters || gridModel.pagingModel[DepsService.config.filtersKey];
  gridModel.pagingModel[DepsService.config.filtersKey] = removeEmptyFilters(gridModel.pagingModel[DepsService.config.filtersKey]);
  gridModel.pagingModel[DepsService.config.pageNoKey] = 0;
  return fetchDataFunc(gridModel);
}

function sortByColumn(gridModel, fetchData, column, direction) {
  gridModel.pagingModel[DepsService.config.sortColumnKey] = column;
  gridModel.pagingModel[DepsService.config.directionKey] = direction.toString();
  return fetchData(gridModel);
}

function changePageSize(gridModel, fetchData, pageSize) {
  gridModel.pagingModel[DepsService.config.pageSizeKey] = pageSize;
  return fetchData(gridModel);
}

export function sortItems(items, column, direction) {
  items = items.map((item) => {
    item[column + 'toLowerCase'] = _.isString(item[column]) ? item[column].toLowerCase() : item[column];
    return item;
  });
  items = _.orderBy(items, [column + 'toLowerCase'], [direction]);
  items = items.map((item) => {
    _.unset(item, [column + 'toLowerCase']);
    return item;
  });
  return items;
}

export function filterItems(items, filters = {}, customHandlers = {}) {
  const filterKeys = Object.keys(filters).filter((item) => filters[item] !== undefined && filters[item] !== null);
  return _.cloneDeep(items).filter((item) => filterKeys.every((key) => (customHandlers[key] || defaultFilterHandler)(item, filters, key)));
}

export function evalMeta(result) {
  return {
    count: result.totalElements,
    pagesCount: result.totalPages,
    page: result.number,
    displayedPage: ++result.number,
    pageSize: result.size,
    hasPreviousPage: result.hasPrevious,
    hasNextPage: result.hasNext,
  };
}

export default {
  setFilters,
  defaultFilterHandler,
};



// WEBPACK FOOTER //
// ./src/modules/utils/grid/grid.js